import React from 'react';
import './InternationalForm.css';

const InternationalForm = () => {
    return (
        <section id="international-form" className="international-form-section">
            <div className="container">
                <div className="form-wrapper">
                    <div className="form-header">
                        <h2>Begin Your International Patient Journey</h2>
                        <p>Complete this form for priority scheduling at our facility</p>
                    </div>
                    
                    <div className="zoho-form-container" style={{
                        width: '100%',
                        minHeight: '1000px',
                        position: 'relative'
                    }}>
                        <iframe 
                            src='https://forms.zohopublic.eu/ampedtherapeutics1/form/ScheduleYourConsultationForm/formperma/aWHyh11TAcGqDsy812C7c-fE1TBONsP4FDqB2Wc2OJY'
                            style={{
                                width: '100%',
                                height: '1200px',
                                border: 'none',
                                borderRadius: '10px'
                            }}
                            title="International Patient Consultation Form"
                            scrolling="auto"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InternationalForm;